import React from 'react';

const IndexDetail = ({ index }) => {
  return <div>IndexDetail</div>;
};

export default IndexDetail;
